let host = null

export function registerConfirmDialogHost(instance) {
  host = instance || null
}

/**
 * @param {object} options
 * @param {string} [options.title]
 * @param {string} [options.message]
 * @param {string} [options.eyebrow]
 * @param {string} [options.confirmText]
 * @param {string} [options.cancelText]
 * @param {'default'|'danger'} [options.tone]
 * @returns {Promise<boolean>}
 */
export function showConfirm(options = {}) {
  if (host && typeof host.open === 'function') {
    return host.open(options)
  }
  const fallback = options.message || options.title || '确认操作？'
  return Promise.resolve(window.confirm(fallback))
}
